import React, {FC} from 'react';
import styled from 'styled-components';

import {TooltipCoordinator} from '../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {boxShadow} from '../../../../libs/shared/ui/src/theme/themeStyleHelpers';
import {MultilineTooltipOverflowCondition} from '../tooltips/multilineTooltipOverflowCondition';

/*
 * Props.
 */

interface ApplicationCategoryCardProps {
  title: React.ReactNode;
  description: React.ReactNode;
  children: React.ReactNode;
}

/*
 * Style.
 */

const StyledCategoryWrapperDiv = styled.div`
  display: flex;
  flex-flow: column;
  gap: 8px;
  padding: 20px;
  border: 1px solid ${(p) => p.theme.alphas.black20};
  ${(p) => boxShadow(p.theme, `0px 1px 9px ${p.theme.alphas.black20}`)};
  border-radius: 16px;
`;

const StyledTitleDiv = styled.div`
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.large};
  overflow: hidden;
  flex: 1;
`;

const StyledDescriptionDiv = styled.div`
  font-size: ${fontSizes.medium};
  color: ${(p) => p.theme.greys.shade70};
  overflow: hidden;
  height: 40px;
  line-height: 20px;
`;

const StyledChildrenWrapperDiv = styled.div`
  display: flex;
  margin-top: 16px;

  &:empty {
    display: none;
  }
`;

/*
 * Component.
 */

export const ApplicationCategoryCard: FC<ApplicationCategoryCardProps> = (props) => {
  const {title, description, children} = props;

  return (
    <StyledCategoryWrapperDiv>
      <StyledTitleDiv>
        <TooltipCoordinator render={() => title}>
          <MultilineTooltipOverflowCondition>{title}</MultilineTooltipOverflowCondition>
        </TooltipCoordinator>
      </StyledTitleDiv>
      <StyledDescriptionDiv>
        <TooltipCoordinator render={() => description}>
          <MultilineTooltipOverflowCondition>{description}</MultilineTooltipOverflowCondition>
        </TooltipCoordinator>
      </StyledDescriptionDiv>
      <StyledChildrenWrapperDiv>{children}</StyledChildrenWrapperDiv>
    </StyledCategoryWrapperDiv>
  );
};
